import { CreateDealRequestContent, CreateDealResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to create a new deal
 * @param request Deal creation parameters
 * @returns Promise with created deal and initial version
 */
export const createDealApi = async (request: CreateDealRequestContent): Promise<CreateDealResponseContent> => {
  const apiRequest = createApiRequest<CreateDealResponseContent>('post', '/deals/create');
  return apiRequest(request);
};
